import { AMEX } from '../../constants/cardTypes';

/**
 * Dont show security code input when the card type is AMEX
 *
 * @param type - The card type
 */

export default function shouldShowSecurityCode(cardType: string): boolean {
  if (cardType === AMEX) {
    return false;
  }
  return true;
}
